import { Link } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import Typography from '@material-ui/core/Typography';

import AlertIllustration from '../../images/alert.svg';
import TamperTesterHeader from '../TamperTesterHeader';

function VerificationTampering(props) {
	const { t } = useTranslation();
	const theme = useTheme();
	return (
		<>
			<TamperTesterHeader />
			<Container
				maxWidth="sm"
				style={{
					display: 'flex',
					flexDirection: 'column',
					flex: 1,
					justifyContent: 'space-between',
				}}
			>
				<Grid container spacing={3}>
					<Grid
						item
						xs={12}
						style={{
							display: 'flex',
							justifyContent: 'center',
							marginTop: theme.spacing(3),
							marginBottom: theme.spacing(-1),
						}}
					>
						<img src={AlertIllustration} alt="Potential Tampering" />
					</Grid>
					<Grid item xs={12}>
						<Typography
							variant="h4"
							component="h2"
							style={{ textAlign: 'center', color: theme.palette.error.main }}
						>
							{t('verification_tampering.title')}
						</Typography>
					</Grid>

					<Grid item xs={12}>
						<Divider />
					</Grid>
					<Grid item xs={12}>
						<Typography variant="body1" gutterBottom>
							{t('verification_tampering.description_line1')}
						</Typography>
						<Typography variant="body1" gutterBottom>
							{t('verification_tampering.description_line2')}
						</Typography>
						<Typography variant="body1">
							{t('verification_tampering.description_line3')}
						</Typography>
					</Grid>
				</Grid>

				<Grid container spacing={1} style={{ marginBottom: theme.spacing(4) }}>
					<Grid item xs={12}>
						<Button
							component={Link}
							to="/step1"
							variant="contained"
							color="primary"
							fullWidth={true}
							disableElevation={true}
						>
							{t('verification_tampering.scan_next')}
						</Button>
					</Grid>
					<Grid item xs={12}>
						<Button
							href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL_ADDRESS}`}
							variant="outlined"
							color="default"
							fullWidth={true}
							disableElevation={true}
						>
							{t('verification_tampering.contact_us')}
						</Button>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}

export default VerificationTampering;
